import { GlobalContextProvider } from '../GlobalContextProvider';
import type { PageContext } from './PageContext';

export const getPageContext = (): PageContext | undefined => {
    if (GlobalContextProvider.isSpaPage()) {
        return 'spa';
    }

    if (GlobalContextProvider.isModernPage()) {
        return 'modernPage';
    }

    return 'public';
};
